"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "APIContext", {
  enumerable: true,
  get: function get() {
    return _context.default;
  }
});
Object.defineProperty(exports, "APIProvider", {
  enumerable: true,
  get: function get() {
    return _APIProvider.default;
  }
});
Object.defineProperty(exports, "withAPIContext", {
  enumerable: true,
  get: function get() {
    return _withAPIContext.default;
  }
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _apolloClient = require("apollo-client");

var _lib = require("../../lib");

var _common = require("../../common");

var _context = _interopRequireDefault(require("./context"));

var _APIProvider = _interopRequireDefault(require("./APIProvider"));

var _withAPIContext = _interopRequireDefault(require("./withAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var APIProviders = function APIProviders(_ref) {
  var children = _ref.children,
      clients = _ref.clients;
  var context = {
    clients: clients
  };
  return _react.default.createElement(_context.default.Provider, {
    value: context
  }, (0, _lib.getRenderProps)(children, context));
};

APIProviders.propTypes = {
  children: _common.customPropTypes.render,
  clients: _propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.instanceOf(_apolloClient.ApolloClient)))
};
APIProviders.defaultProps = {
  children: null,
  clients: null
};
APIProviders.Consumer = _context.default.Consumer;
var _default = APIProviders;
exports.default = _default;